import React, { useEffect, useState } from 'react';
import LoadingBar from 'react-top-loading-bar';
import { useTransition, animated } from 'react-spring';
import { FaArrowCircleUp, FaAngleDoubleLeft, FaAngleDoubleRight, FaEye } from 'react-icons/fa';
import NavbarDetailBlog from '../../../components/navbarDetailBlog.tsx';
import HeaderDetailBlog from '../utils/headerDetailBlog.tsx';
import Footer from '../../../components/footer.tsx';
import { Link } from 'react-router-dom';
import ImageModal from '../utils/imageModal.tsx';


import usePreventZoom from '../../../preventZoom.js';

import Header from '../../../assets/Blog/ACL/ACL_PART7/Detail/HEADER_DETAIL_ACL_PART7.webp';
import Pict1 from "../../../assets/Blog/ACL/ACL_PART7/Detail/1.webp";
import Pict2 from "../../../assets/Blog/ACL/ACL_PART7/Detail/2.webp";
import Pict3 from "../../../assets/Blog/ACL/ACL_PART7/Detail/3.webp";
import Pict4 from "../../../assets/Blog/ACL/ACL_PART7/Detail/4.webp";
import Pict5 from "../../../assets/Blog/ACL/ACL_PART7/Detail/5.webp";

import Gallery1 from "../../../assets/Blog/ACL/ACL_PART7/Detail/6.webp";
import Gallery2 from "../../../assets/Blog/ACL/ACL_PART7/Detail/7.webp";
import Gallery3 from "../../../assets/Blog/ACL/ACL_PART7/Detail/8.webp";
import Gallery4 from "../../../assets/Blog/ACL/ACL_PART7/Detail/9.webp";
import Gallery5 from "../../../assets/Blog/ACL/ACL_PART7/Detail/10.webp";
import Gallery6 from "../../../assets/Blog/ACL/ACL_PART7/Detail/11.webp";
import Gallery7 from "../../../assets/Blog/ACL/ACL_PART7/Detail/12.webp";
import Gallery8 from "../../../assets/Blog/ACL/ACL_PART7/Detail/13.webp";
import Gallery9 from "../../../assets/Blog/ACL/ACL_PART7/Detail/14.webp";
import Gallery10 from "../../../assets/Blog/ACL/ACL_PART7/Detail/15.webp";
import Gallery11 from "../../../assets/Blog/ACL/ACL_PART7/Detail/16.webp";
import Gallery12 from "../../../assets/Blog/ACL/ACL_PART7/Detail/17.webp";
import Gallery13 from "../../../assets/Blog/ACL/ACL_PART7/Detail/18.webp";
import Gallery14 from "../../../assets/Blog/ACL/ACL_PART7/Detail/19.webp";
import Gallery15 from "../../../assets/Blog/ACL/ACL_PART7/Detail/20.webp";
import Gallery16 from "../../../assets/Blog/ACL/ACL_PART7/Detail/21.webp";
import Gallery17 from "../../../assets/Blog/ACL/ACL_PART7/Detail/22.webp";
import Gallery18 from "../../../assets/Blog/ACL/ACL_PART7/Detail/23.webp";
import Gallery19 from "../../../assets/Blog/ACL/ACL_PART7/Detail/24.webp";
import Gallery20 from "../../../assets/Blog/ACL/ACL_PART7/Detail/25.webp";
import Gallery21 from "../../../assets/Blog/ACL/ACL_PART7/Detail/26.webp";
import Gallery22 from "../../../assets/Blog/ACL/ACL_PART7/Detail/27.webp";
import Gallery23 from "../../../assets/Blog/ACL/ACL_PART7/Detail/28.webp";
import Gallery24 from "../../../assets/Blog/ACL/ACL_PART7/Detail/29.webp";
import Gallery25 from "../../../assets/Blog/ACL/ACL_PART7/Detail/30.webp";
import Gallery26 from "../../../assets/Blog/ACL/ACL_PART7/Detail/31.webp";
import Gallery27 from "../../../assets/Blog/ACL/ACL_PART7/Detail/32.webp";
import Gallery28 from "../../../assets/Blog/ACL/ACL_PART7/Detail/33.webp";
import Gallery29 from "../../../assets/Blog/ACL/ACL_PART7/Detail/34.webp";
import Gallery30 from "../../../assets/Blog/ACL/ACL_PART7/Detail/35.webp";
import Gallery31 from "../../../assets/Blog/ACL/ACL_PART7/Detail/36.webp";
import Gallery32 from "../../../assets/Blog/ACL/ACL_PART7/Detail/37.webp";
import Gallery33 from "../../../assets/Blog/ACL/ACL_PART7/Detail/38.webp";

import CommentListExample from '../../../components/comments/commentListExample.tsx';

const ACLPART7: React.FC = () => {
    const [isMd, setIsMd] = useState(window.matchMedia('(min-width: 900px)').matches);
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedAlt, setSelectedAlt] = useState('');
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(30);
        setTimeout(() => {
            setProgress(100);
        }, 600);
    }, []);
  
    const openModal = (imageUrl, imageAlt) => {
        setSelectedImage(imageUrl);
        setSelectedAlt(imageAlt);
        setModalVisible(true);
    };
  
    const closeModal = () => {
        setSelectedImage('');
        setSelectedAlt('');
        setModalVisible(false);
    };


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 900px)');
        const updateIsMd = () => {
            setIsMd(mediaQuery.matches);
        };

        mediaQuery.addListener(updateIsMd);
        return () => {
            mediaQuery.removeListener(updateIsMd);
        };
    }, []);

    const handleScroll = () => {
        if (window.scrollY > 350) {
            setShowScrollToTop(true);
        } else {
            setShowScrollToTop(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const arrowTransition = useTransition(showScrollToTop, {
        from: { opacity: 0, transform: 'translateY(100%)' },
        enter: { opacity: 1, transform: 'translateY(0%)' },
        leave: { opacity: 0, transform: 'translateY(100%)' },
        config: { tension: 300, friction: 20 },
      });

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: false});
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    usePreventZoom();

    return(
        <div className='App'>
            <NavbarDetailBlog/>
            <div className='pt-20 min-w-screen font-condensed text-textGrey'>
                {/* Loading Bar */}
                <LoadingBar color="#8C001f" progress={progress} onLoaderFinished={() => setProgress(0)} />
                <section className='hidden w-64 mr-10 group transform hover:translate-y-[-5px] transition-transform duration-300 ease-in-out'>
                        <script type='text/javascript' id='mapmyvisitors' src='https://mapmyvisitors.com/map.js?cl=e1e1e1&w=300&t=n&d=fngBtcVXvPP4eW7t-ugYnO9uc3XJHrNYu7CAB7PGnao&co=ffffff&cmo=8c001f&cmn=d4201e&ct=ffffff'></script>
                </section>
                <HeaderDetailBlog backgroundImage={Header} title="Vienna, One Last Walk (Part 7)" date="1" year="August, 2025" backgroundPosition="center center"></HeaderDetailBlog>
                <div className='author-article text-end pr-4 pt-8 pb-4 text-xs'>
                    <p className='font-condensed text-textGrey'>by Mohammad Rifqi Farhansyah | Association for Computational Linguistics 2025</p>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict1, 'Photo in front of Hofburg Wien and the museum side.')}>
                            <img
                                src={Pict1}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo in front of Hofburg Wien and the museum side."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo in front of Hofburg Wien and the museum side.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Hofburg Wien, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-2xl'>I have been in Vienna for quite a while, but only today did I really get the chance to explore the city more deeply.</p>
                        <br/>
                        <p className='text-lg'>
                            Today, August 1, 2025, was my last day in Vienna, Austria. Tomorrow morning, I would be heading back home. My flight was very early, so I had to prepare to go to the airport in the middle of the night. Because of that, Kak Iwan and I planned to spend today walking around Vienna while buying souvenirs to bring home.
                        </p>
                        <br/>
                        <p className='text-lg'>
                            Our first destination was the Museum Quarter and Hofburg Wien. The classic European architecture with green rooftops looked amazing as a photo background. Around the area, there were several food stalls, a playground, and even a university nearby, Technische Universität Wien. The city layout around this area felt incredibly beautiful and well organized.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict2, 'Photo at Stephansplatz.')}>
                            <img
                                src={Pict2}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Photo at Stephansplatz."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Photo at Stephansplatz.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Stephansplatz, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After taking enough photos and enjoying the view around the Museum Quarter, we continued our journey to Stephansplatz, one of the most iconic landmarks in Vienna. Almost every snow globe sold in souvenir shops has a miniature of this building inside. The area was quite crowded that day. We walked around, took photos, and browsed nearby shops. At first, we wanted to look for food there, since it was our last day. But after some thought, we decided it would probably be too expensive, and it would be better to save the money for the next destination. In the end, we bought ice cream for one euro. Eating cold ice cream under the heat of Vienna’s city center felt perfect. I chose pineapple flavor, and it felt incredibly refreshing.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict3, 'Buying souvenirs at Naschmarkt.')}>
                            <img
                                src={Pict3}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Buying souvenirs at Naschmarkt."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Buying souvenirs at Naschmarkt.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Naschmarkt, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After spending some time around Stephansplatz, Kak Iwan and I realized we could not stay there too long. We still needed to buy souvenirs, and souvenir shopping takes time because of all the choosing and comparing. So we decided to move on to the next place, Naschmarkt, the same area where Prof. Derry treated us to dinner before. At Naschmarkt, the entire street was filled with souvenir shops. Some sold trinkets, T-shirts, sweets, durum, and many other things. Once we arrived, we split tasks. I surveyed the shops in the first half, while Kak Iwan checked the shops in the second half. In the end, we found that different shops were cheaper for different items. Shop A had cheaper clothes, Shop B had cheaper keychains, Shop C had cheaper snow globes. Some shops were also cheaper depending on how many items you bought. After comparing everything, we went back to the selected shops. I bought T-shirts for my dad, a music box for my sibling, a headscarf for my mom, keychains for family and friends, and some chocolates and snow globes as extras.
                        </p>
                    </div>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-36 mb-20'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict4, 'Last photo in front of the ACL 2025 Vienna sign.')}>
                            <img
                                src={Pict4}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Last photo in front of the ACL 2025 Vienna sign."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Last photo in front of the ACL 2025 Vienna sign.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Austria Center Vienna, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            After everything was done, Kak Iwan and I decided not to go straight back to the apartment. Instead, we went to Austria Center Vienna. It felt like we just wanted to say goodbye to ACL 2025. There were so many valuable experiences, new connections, and burning motivation that ACL 2025 gave both of us. Hopefully, one day we can come back here again, either to Vienna or to future ACL conferences in other countries. We also met several other attendees there, and some of them were already carrying suitcases. I guess they were heading home that day as well. After that, we planned to return to the apartment for a while and wait for our evening plan.
                        </p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-36 mb-20'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        Vienna will always be a beautiful story in my memory.
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
                <div className='bg-fixed bg-center w-full h-96 md:mb-36 mb-20' style={{ backgroundImage: `url(${Header})`, backgroundSize: 'cover',}}>
                </div>
                <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-16 mb-8'>
                    <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                        <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Pict5, 'Watching a Mozart concert.')}>
                            <img
                                src={Pict5}
                                className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                                alt="Watching a Mozart concert."
                            />
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                    <FaEye className="text-textRed text-5xl" />
                                </div>
                            </div>
                        </div>
                        <div className='article-content__image__desc   w-full h-auto'>
                            <p className='text-lg font-condensed text-start'><i>Watching a Mozart concert.</i></p>
                            <p className='text-sm font-condensed text-start'><i>©2025 Rifqi | Mozart Concert, Austria</i></p>
                        </div>
                    </div>
                    <div className='article-content__text md:w-2/3 w-full h-auto text-justify'>
                        <p className='text-lg'>
                            That evening, Kak Iwan, Kak Lucky, Mussa, and I planned to watch a Mozart concert. Prof. Derry had watched it earlier and said that even though she is not really into music, she was deeply moved by it. Hearing that made us even more interested. In the end, we decided to go. We only bought standing tickets because seated tickets were insanely more expensive. We also shared the cost of a small booklet listing the songs that would be played. We arrived at Musikvereinsplatz very early, about one hour before the concert started. We saw several people wearing Mozart-style costumes, complete with white curly wigs. The Amadeus 1984 vibes were really strong that evening. When the doors opened, we immediately registered and rushed in to get a more comfortable standing spot. The concert began, and somehow my legs did not feel tired at all, even though it lasted for more than an hour. The music went straight to my heart. I was genuinely moved listening to it. Even after leaving the concert, the sound of The Magic Flute kept echoing in my head. It was truly a very sweet ending to my last day in Vienna. Hopefully, one day I can return to Vienna and its Mozart concert again, and hopefully next time, I can sit in the front row.
                        </p>
                        <div className='article-break-1 flex justify-start items-center flex-col'>
                            <hr className='w-full mt-4 mb-4  border-t border-b border-solid'/>
                        </div>
                        <p className='text-lg font-bold'><i>to be continued...</i></p>
                    </div>
                </div>
                <div className='article-break-1 flex justify-center items-center flex-col md:mb-8 mb-4'>
                    <hr className='w-5/6 mt-4 md:mb-12 mb-4  border-t border-b border-solid'/>
                    <p className='md:text-5xl text-2xl font-bold text-black md:px-44 px-10'>
                        "
                        Life is like a Mozart symphony.
                        "
                    </p>
                    <hr className='w-5/6 mb-4 md:mt-12 mt-4 border-t border-b border-solid'/>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery1, "Photo Recap: Last day in Vienna (Part 1).")}>
                        <img
                            src={Gallery1}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 1)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 1).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery2, "Photo Recap: Last day in Vienna (Part 2).")}>
                        <img
                            src={Gallery2}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 2)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 2).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery3, "Photo Recap: Last day in Vienna (Part 3).")}>
                        <img
                            src={Gallery3}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 3)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 3).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery4, "Photo Recap: Last day in Vienna (Part 4).")}>
                        <img
                            src={Gallery4}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 4)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 4).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery5, "Photo Recap: Last day in Vienna (Part 5).")}>
                        <img
                            src={Gallery5}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 5)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 5).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery6, "Photo Recap: Last day in Vienna (Part 6).")}>
                        <img
                            src={Gallery6}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 6)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 6).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery7, "Photo Recap: Last day in Vienna (Part 7).")}>
                        <img
                            src={Gallery7}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 7)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 7).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery8, "Photo Recap: Last day in Vienna (Part 8).")}>
                        <img
                            src={Gallery8}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 8)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 8).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery9, "Photo Recap: Last day in Vienna (Part 9).")}>
                        <img
                            src={Gallery9}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 9)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 9).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery10, "Photo Recap: Last day in Vienna (Part 10).")}>
                        <img
                            src={Gallery10}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 10)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 10).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery11, "Photo Recap: Last day in Vienna (Part 11).")}>
                        <img
                            src={Gallery11}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 11)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 11).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery12, "Photo Recap: Last day in Vienna (Part 12).")}>
                        <img
                            src={Gallery12}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 12)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 12).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery13, "Photo Recap: Last day in Vienna (Part 13).")}>
                        <img
                            src={Gallery13}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 13)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 13).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery14, "Photo Recap: Last day in Vienna (Part 14).")}>
                        <img
                            src={Gallery14}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 14)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 14).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery15, "Photo Recap: Last day in Vienna (Part 15).")}>
                        <img
                            src={Gallery15}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 15)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 15).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery16, "Photo Recap: Last day in Vienna (Part 16).")}>
                        <img
                            src={Gallery16}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 16)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 16).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery17, "Photo Recap: Last day in Vienna (Part 17).")}>
                        <img
                            src={Gallery17}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 17)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 17).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery18, "Photo Recap: Last day in Vienna (Part 18).")}>
                        <img
                            src={Gallery18}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 18)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 18).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery19, "Photo Recap: Last day in Vienna (Part 19).")}>
                        <img
                            src={Gallery19}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 19)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 19).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery20, "Photo Recap: Last day in Vienna (Part 20).")}>
                        <img
                            src={Gallery20}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 20)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 20).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery21, "Photo Recap: Last day in Vienna (Part 21).")}>
                        <img
                            src={Gallery21}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 21)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 21).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery22, "Photo Recap: Last day in Vienna (Part 22).")}>
                        <img
                            src={Gallery22}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 22)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 22).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery23, "Photo Recap: Last day in Vienna (Part 23).")}>
                        <img
                            src={Gallery23}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 23)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 23).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery24, "Photo Recap: Last day in Vienna (Part 24).")}>
                        <img
                            src={Gallery24}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 24)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 24).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery25, "Photo Recap: Last day in Vienna (Part 25).")}>
                        <img
                            src={Gallery25}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 25)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 25).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery26, "Photo Recap: Last day in Vienna (Part 26).")}>
                        <img
                            src={Gallery26}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 26)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 26).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery27, "Photo Recap: Last day in Vienna (Part 27).")}>
                        <img
                            src={Gallery27}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 27)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 27).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery28, "Photo Recap: Last day in Vienna (Part 28).")}>
                        <img
                            src={Gallery28}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 28)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 28).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery29, "Photo Recap: Last day in Vienna (Part 29).")}>
                        <img
                            src={Gallery29}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 29)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 29).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery30, "Photo Recap: Last day in Vienna (Part 30).")}>
                        <img
                            src={Gallery30}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 30)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 30).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='article-content-1 md:flex md:flex-row flex flex-col md:px-10 px-10 gap-x-4 gap-y-4 md:mb-20 mb-8'>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery31, "Photo Recap: Last day in Vienna (Part 31).")}>
                        <img
                            src={Gallery31}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 31)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 31).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery32, "Photo Recap: Last day in Vienna (Part 32).")}>
                        <img
                            src={Gallery32}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 32)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 32).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
                <div className='article-content__image space-y-4 md:w-1/3 w-full h-auto'>
                    <div className="relative overflow-hidden group shadow-lg cursor-pointer" onClick={() => openModal(Gallery33, "Photo Recap: Last day in Vienna (Part 33).")}>
                        <img
                            src={Gallery33}
                            className='w-full h-auto cursor-pointer transform transition-transform duration-300 group-hover:scale-105'
                            alt="Photo Recap: Last day in Vienna (Part 33)."
                        />
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="bg-white bg-opacity-70 opacity-0 transition-opacity duration-300 group-hover:opacity-100 absolute inset-0 flex items-center justify-center">
                                <FaEye className="text-textRed text-5xl" />
                            </div>
                        </div>
                    </div>
                    <div className='article-content__image__desc   w-full h-auto md:px-0'>
                        <p className='text-lg font-condensed text-start'><i>Photo Recap: Last day in Vienna (Part 33).</i></p>
                        <p className='text-sm font-condensed text-start'><i>©2025 Rifqi</i></p>
                    </div>
                </div>
            </div>
            <div className='flex justify-center items-center px-12 md:mb-8 mb-4 gap-x-8'>
                <Link to="/acl/acl-part6" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    <FaAngleDoubleLeft className='w-3 h-3 text-textRed inline-block mr-1' />
                    PREV 
                </Link>
                <Link to="/acl/acl-part8" className='md:text-xl text-lg text-textRed font-bold flex items-center hover:scale-105'>
                    NEXT 
                    <FaAngleDoubleRight className='w-3 h-3 text-textRed inline-block ml-1' />
                </Link>
            </div>
            <div className='bg-fixed w-full h-96' style={{ backgroundImage: `url(${Pict4})`, backgroundSize: 'cover',  }}>
            </div>
            <CommentListExample postId={7} seriesId={2}/>
            <ImageModal
                showModal={modalVisible}
                closeModal={closeModal}
                imageUrl={selectedImage}
                imageAlt={selectedAlt}
            />
            <Footer/>
            {arrowTransition((style, item) =>
                item ? (
                <animated.div
                    style={style}
                    className="fixed bottom-5 right-5 cursor-pointer z-10"
                    onClick={scrollToTop}
                >
                    <FaArrowCircleUp
                    size={isMd ? 32 : 24}
                    className="text-[#c0c5ca] hover:scale-110"
                    />
                </animated.div>
                ) : null
            )}
        </div>
    );
};

export default ACLPART7